import styled from 'styled-components';
import Spinner from '@carvana/ds-spinner';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;

const LoadingSpinner = () => (
  <Wrapper>
    <Spinner size={64} />
  </Wrapper>
);

export default LoadingSpinner;
